/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { absDependencies } from './dependenciesAbs.generated.js';
import { addDependencies } from './dependenciesAdd.generated.js';
import { concatDependencies } from './dependenciesConcat.generated.js';
import { identityDependencies } from './dependenciesIdentity.generated.js';
import { indexDependencies } from './dependenciesIndex.generated.js';
import { lusolveDependencies } from './dependenciesLusolve.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { matrixFromColumnsDependencies } from './dependenciesMatrixFromColumns.generated.js';
import { multiplyDependencies } from './dependenciesMultiply.generated.js';
import { rangeDependencies } from './dependenciesRange.generated.js';
import { schurDependencies } from './dependenciesSchur.generated.js';
import { subsetDependencies } from './dependenciesSubset.generated.js';
import { subtractDependencies } from './dependenciesSubtract.generated.js';
import { transposeDependencies } from './dependenciesTranspose.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSylvester } from '../../factoriesAny.js';
export var sylvesterDependencies = {
  absDependencies,
  addDependencies,
  concatDependencies,
  identityDependencies,
  indexDependencies,
  lusolveDependencies,
  matrixDependencies,
  matrixFromColumnsDependencies,
  multiplyDependencies,
  rangeDependencies,
  schurDependencies,
  subsetDependencies,
  subtractDependencies,
  transposeDependencies,
  typedDependencies,
  createSylvester
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesSylvester.generated.js
// module id = 572
// module chunks = 2